// The roles in our backend have different capitalisation: "user" and "Administrator"
export const USER_ROLE_VALUE = "user";
export const ADMINISTRATOR_ROLE_VALUE = "Administrator";
